import { template } from "@ember/template-compiler";
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import './footer.scss';
export default template(`
  <div
    class="cost-estimator-footer"
    ...attributes
    data-test-cost-estimator-footer-container
  >
    {{#if (has-block "controls")}}
      <div
        class="cost-estimator-footer__controls"
        data-test-cost-estimator-footer-controls
      >
        {{yield to="controls"}}
      </div>
      <div
        class="cost-estimator-footer__message"
        data-test-cost-estimator-footer-message
      >
        {{#if (has-block "message")}}
          {{yield to="message"}}
        {{else}}
          <p>
            {{t "billing-common.cost-estimator.footer.pay-as-you-go"}}
          </p>
          <p>
            {{t "billing-common.cost-estimator.footer.cost-is-based"}}
          </p>
        {{/if}}
      </div>
    {{/if}}
    {{#if (and (not @error) (has-block "left"))}}
      <div
        class="cost-estimator-footer__left-estimate"
        data-test-cost-estimator-footer-left-estimate
      >
        {{yield to="left"}}
      </div>
    {{/if}}
    {{#if (and (not @error) (has-block "right"))}}
      <div
        class="cost-estimator-footer__right-estimate"
        data-test-cost-estimator-footer-right-estimate
      >
        {{yield to="right"}}
      </div>
    {{/if}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci9hY3Rpb25zLXJ1bm5lci9fd29yay9jbG91ZC11aS9jbG91ZC11aS9hZGRvbnMvYmlsbGluZy1jb21tb24vcGFja2FnZS9zcmMvY29tcG9uZW50cy9iaWxsaW5nL2Nvc3QtZXN0aW1hdG9yL2Zvb3Rlci5nanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdCB9IGZyb20gJ2VtYmVyLWludGwnO1xuaW1wb3J0IHsgYW5kLCBub3QgfSBmcm9tICdlbWJlci10cnV0aC1oZWxwZXJzJztcblxuaW1wb3J0ICcuL2Zvb3Rlci5zY3NzJztcblxuPHRlbXBsYXRlPlxuICA8ZGl2XG4gICAgY2xhc3M9XCJjb3N0LWVzdGltYXRvci1mb290ZXJcIlxuICAgIC4uLmF0dHJpYnV0ZXNcbiAgICBkYXRhLXRlc3QtY29zdC1lc3RpbWF0b3ItZm9vdGVyLWNvbnRhaW5lclxuICA-XG4gICAge3sjaWYgKGhhcy1ibG9jayBcImNvbnRyb2xzXCIpfX1cbiAgICAgIDxkaXZcbiAgICAgICAgY2xhc3M9XCJjb3N0LWVzdGltYXRvci1mb290ZXJfX2NvbnRyb2xzXCJcbiAgICAgICAgZGF0YS10ZXN0LWNvc3QtZXN0aW1hdG9yLWZvb3Rlci1jb250cm9sc1xuICAgICAgPlxuICAgICAgICB7e3lpZWxkIHRvPVwiY29udHJvbHNcIn19XG4gICAgICA8L2Rpdj5cbiAgICAgIDxkaXZcbiAgICAgICAgY2xhc3M9XCJjb3N0LWVzdGltYXRvci1mb290ZXJfX21lc3NhZ2VcIlxuICAgICAgICBkYXRhLXRlc3QtY29zdC1lc3RpbWF0b3ItZm9vdGVyLW1lc3NhZ2VcbiAgICAgID5cbiAgICAgICAge3sjaWYgKGhhcy1ibG9jayBcIm1lc3NhZ2VcIil9fVxuICAgICAgICAgIHt7eWllbGQgdG89XCJtZXNzYWdlXCJ9fVxuICAgICAgICB7e2Vsc2V9fVxuICAgICAgICAgIDxwPlxuICAgICAgICAgICAge3t0IFwiYmlsbGluZy1jb21tb24uY29zdC1lc3RpbWF0b3IuZm9vdGVyLnBheS1hcy15b3UtZ29cIn19XG4gICAgICAgICAgPC9wPlxuICAgICAgICAgIDxwPlxuICAgICAgICAgICAge3t0IFwiYmlsbGluZy1jb21tb24uY29zdC1lc3RpbWF0b3IuZm9vdGVyLmNvc3QtaXMtYmFzZWRcIn19XG4gICAgICAgICAgPC9wPlxuICAgICAgICB7ey9pZn19XG4gICAgICA8L2Rpdj5cbiAgICB7ey9pZn19XG4gICAge3sjaWYgKGFuZCAobm90IEBlcnJvcikgKGhhcy1ibG9jayBcImxlZnRcIikpfX1cbiAgICAgIDxkaXZcbiAgICAgICAgY2xhc3M9XCJjb3N0LWVzdGltYXRvci1mb290ZXJfX2xlZnQtZXN0aW1hdGVcIlxuICAgICAgICBkYXRhLXRlc3QtY29zdC1lc3RpbWF0b3ItZm9vdGVyLWxlZnQtZXN0aW1hdGVcbiAgICAgID5cbiAgICAgICAge3t5aWVsZCB0bz1cImxlZnRcIn19XG4gICAgICA8L2Rpdj5cbiAgICB7ey9pZn19XG4gICAge3sjaWYgKGFuZCAobm90IEBlcnJvcikgKGhhcy1ibG9jayBcInJpZ2h0XCIpKX19XG4gICAgICA8ZGl2XG4gICAgICAgIGNsYXNzPVwiY29zdC1lc3RpbWF0b3ItZm9vdGVyX19yaWdodC1lc3RpbWF0ZVwiXG4gICAgICAgIGRhdGEtdGVzdC1jb3N0LWVzdGltYXRvci1mb290ZXItcmlnaHQtZXN0aW1hdGVcbiAgICAgID5cbiAgICAgICAge3t5aWVsZCB0bz1cInJpZ2h0XCJ9fVxuICAgICAgPC9kaXY-XG4gICAge3svaWZ9fVxuICA8L2Rpdj5cbjwvdGVtcGxhdGU-XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLFNBQVMsQ0FBQyxRQUFRLGFBQWE7QUFDL0IsU0FBUyxHQUFHLEVBQUUsR0FBRyxRQUFRLHNCQUFzQjtBQUUvQyxPQUFPLGdCQUFnQjtBQUV2QixlQUFBLFNBQVUsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQThDVixDQUFBLEVBQUE7SUFBQTtRQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUEsR0FBQyJ9